/* unplugin-vue-components disabled */import { render } from "./ArtistDetail.vue?vue&type=template&id=8a4eb6b6&ts=true"
import script from "./ArtistDetail.vue?vue&type=script&lang=ts"
export * from "./ArtistDetail.vue?vue&type=script&lang=ts"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/artistDetail/ArtistDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8a4eb6b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8a4eb6b6', __exports__)) {
    console.log('reload')
    api.reload('8a4eb6b6', __exports__)
  }
  
  module.hot.accept("./ArtistDetail.vue?vue&type=template&id=8a4eb6b6&ts=true", () => {
    console.log('re-render')
    api.rerender('8a4eb6b6', render)
  })

}


export default __exports__